import React, {useMemo, useState} from "react"
import {widgetFromDomaintypeGenerator} from "../../../misc/widget-functions"
import {buildDefaultEntry} from "../../../misc/default-registry"
import QuestionMultiCard from "./QuestionMultiCard"
import QuestionMultiBorderless from "./QuestionMultiBorderless"

const variants = {
    DEFAULT: QuestionMultiCard,
    BORDERLESS: QuestionMultiBorderless,
}

const QuestionMulti = ({questionaire, questiongroup, getDataFromPointer, updateData, value, triggerAction, contextArea, variant = "DEFAULT"}) => {
    const [currentIndex, setCurrentIndex] = useState(0)
    const questionList = questiongroup.children

    const notifyContextArea = (newList) => {
        if (contextArea) {
            triggerAction("UPDATE_CONTEXTAREA", {contextArea, value: newList, merkmal: questiongroup})
        }
    }

    const handleAdd = () => {
        const newList = [...value, buildDefaultEntry(questiongroup.pointer)]
        updateData(newList, questiongroup.pointer)
        setCurrentIndex(newList.length - 1)
        notifyContextArea(newList)
    }

    const handleDelete = () => {
        if (value.length <= 0) return
        const newList = value.filter((_, i) => i !== currentIndex)
        updateData(newList, questiongroup.pointer)
        setCurrentIndex(Math.max(0, currentIndex - 1))
        notifyContextArea(newList)
    }

    const widgetLists = useMemo(() => {
        return questionList.filter(entry => entry.active).map((question) => {
            const indexedPointer = question.pointer?.replace("[i]", currentIndex)

            return widgetFromDomaintypeGenerator(question, indexedPointer)
        })
    }, [questiongroup, currentIndex, questionList])

    const Variant = variants[variant] ?? QuestionMultiCard

    return (
        <Variant
            questionaire={questionaire}
            questiongroup={questiongroup}
            questionList={questionList}
            value={value}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            handleAdd={handleAdd}
            handleDelete={handleDelete}
            widgetLists={widgetLists}
            getDataFromPointer={getDataFromPointer}
        />
    )
}

export default QuestionMulti
